// extracted by mini-css-extract-plugin
var _1 = "_nayueMnaS3n4G3LaZXg";
export { _1 as "radio" }
